export const JOB_LISTING_REQUEST = "JOB_LISTING_REQUEST";
export const JOB_LISTING_FOR_CANDIDATE_REQUEST = "JOB_LISTING_FOR_CANDIDATE_REQUEST";

export const CANDIDATE_FOR_JOBS_LISTING_REQUEST = "CANDIDATE_FOR_JOBS_LISTING_REQUEST";
export const JOB_DEACTIVATE_REQUEST = "JOB_DEACTIVATE_REQUEST";

export const COMPANY_LISTING_REQUEST = "COMPANY_LISTING_REQUEST";


export const COMPANY_DETAILS_SUMMARY_REQUEST = "COMPANY_DETAILS_SUMMARY_REQUEST";